/* Presentation only: Shopify and Kaching retain every buying control and cart operation. */
// Keep the primary photograph visible until a real alternate has loaded.
const readyCardPhoto = (image) => {
  if (image.matches?.('.mz-card-photo__alternate') && image.naturalWidth > 0)
    image.closest('.mz-card-photo').dataset.alternateReady = 'true';
};
document.addEventListener('load', event => readyCardPhoto(event.target), true);
document.querySelectorAll('.mz-card-photo__alternate').forEach(readyCardPhoto);
document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  const menu = document.querySelector(".mz-mobile-menu[open]");
  if (menu) {
    menu.open = false;
    menu.querySelector("summary").focus();
  }
});
let cartCountRefreshTimer;
let cartCountRequest = 0;
const refreshCartCount = async () => {
  const request = ++cartCountRequest;
  try {
    const response = await fetch(
      `${window.Shopify?.routes?.root || "/"}cart.js`,
      { headers: { Accept: "application/json" } },
    );
    if (!response.ok) return;
    const cart = await response.json();
    if (request !== cartCountRequest || !Number.isInteger(cart.item_count)) return;
    document
      .querySelectorAll("[data-mz-cart-count]")
      .forEach((node) => (node.textContent = cart.item_count));
    document
      .querySelector(".mz-bag")
      ?.setAttribute("aria-label", `Bag, ${cart.item_count} items`);
  } catch {
    /* The native cart remains authoritative when the count cannot refresh. */
  }
};
// Vitals intercepts additions and does not emit the theme's cart:update event.
// Opening refreshes additions; closing refreshes quantity edits and removals.
for (const name of ["cart:update", "vitals:cart-drawer:opened", "vitals:cart-drawer:closed"]) {
  document.addEventListener(name, () => {
    clearTimeout(cartCountRefreshTimer);
    cartCountRefreshTimer = setTimeout(refreshCartCount, 150);
  });
}

// Homepage films loop silently while their photographed scene is exposed.
// A sticky scene can intersect the viewport even after its product sheet covers it.
(() => {
  const sections = [...document.querySelectorAll('[data-mz-film]')].filter(section => section.closest('.mz-home'));
  if (!sections.length) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const restricted = () => reduced.matches || Boolean(connection?.saveData);
  const header = document.querySelector('#shopify-section-mz-header, #header-group');
  const films = sections.map(section => ({
    section, video:section.querySelector('video'), control:section.querySelector('.mz-home-film-surface'),
    cover:section.nextElementSibling?.matches('.mz-chapter-products') ? section.nextElementSibling : null,
    intersecting:!('IntersectionObserver' in window), visible:false, failed:false,
    pausedByUser:false, userStarted:false, blocked:false, pending:false, retryAfterPending:false,
  })).filter(film => film.video);
  if (!films.length) return;
  const allowed = film => film.visible && !document.hidden && !film.failed && !film.blocked && !film.pausedByUser && (!restricted() || film.userStarted);
  const render = film => {
    if (!film.control) return;
    const available = film.visible && !document.hidden && !film.failed;
    film.control.hidden = !available;
    film.control.tabIndex = available ? 0 : -1;
    const playing = !film.video.paused || (film.pending && allowed(film));
    film.control.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${film.control.dataset.filmName || 'film'}`);
  };
  const sync = film => {
    const {video} = film;
    video.muted = true;
    if (!allowed(film)) { video.pause(); render(film); return; }
    if (film.pending) {
      if (video.paused) film.retryAfterPending = true;
      render(film);
      return;
    }
    if (!video.paused) { render(film); return; }
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    film.pending = true;
    film.retryAfterPending = false;
    const rejected = error => {
      // An autoplay restriction is retryable by a real click. Do not repeatedly
      // retry it on scroll, or mistake a deliberate pause for broken media.
      if (error?.name !== 'AbortError') film.blocked = true;
    };
    const settled = () => {
      film.pending = false;
      if (!allowed(film)) video.pause();
      else if (film.retryAfterPending && video.paused) sync(film);
      render(film);
    };
    try { Promise.resolve(video.play()).catch(rejected).finally(settled); }
    catch (error) { rejected(error); settled(); }
    render(film);
  };
  const measure = film => {
    if (!film.intersecting || document.hidden) return false;
    const video = film.video.getBoundingClientRect();
    const art = film.video.parentElement.getBoundingClientRect();
    const section = film.section.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const headerRect = header?.getBoundingClientRect();
    const headerBottom = headerRect && headerRect.top <= 0 && headerRect.bottom > 0 ? headerRect.bottom : 0;
    // Intersect the media with its actual clipping containers, not the whole
    // gifting section (whose copy can remain visible after its film leaves).
    const left = Math.max(video.left, art.left, section.left, 0);
    const right = Math.min(video.right, art.right, section.right, viewportWidth);
    const top = Math.max(video.top, art.top, section.top, headerBottom);
    const bottom = Math.min(video.bottom, art.bottom, section.bottom, viewportHeight);
    const width = Math.max(0, right - left), height = Math.max(0, bottom - top);
    let exposed = width * height;
    if (film.cover && exposed) {
      const cover = film.cover.getBoundingClientRect();
      exposed -= Math.max(0, Math.min(right, cover.right) - Math.max(left, cover.left)) * Math.max(0, Math.min(bottom, cover.bottom) - Math.max(top, cover.top));
    }
    const fullWidth = Math.min(video.width, art.width, section.width, viewportWidth);
    const fullHeight = Math.min(video.height, art.height, section.height, viewportHeight - headerBottom);
    return fullWidth > 0 && fullHeight > 0 && exposed / (fullWidth * fullHeight) >= .1;
  };
  let frame = 0;
  const refresh = () => {
    frame = 0;
    films.forEach(film => { film.visible = measure(film); sync(film); });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(refresh); };
  for (const film of films) {
    const {video, control} = film;
    video.loop = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    control?.addEventListener('click', () => {
      if (!video.paused || (film.pending && allowed(film))) {
        film.pausedByUser = true;
        film.userStarted = false;
      } else {
        film.pausedByUser = false;
        film.userStarted = true;
        film.blocked = false;
      }
      film.visible = measure(film);
      sync(film);
    });
    video.addEventListener('playing', () => {
      // A delayed play promise/event cannot restart hidden or manually paused media.
      if (!allowed(film)) video.pause();
      else film.section.setAttribute('data-film-ready', '');
      render(film);
    });
    video.addEventListener('pause', () => render(film));
    video.addEventListener('error', () => {
      film.failed = true;
      film.section.removeAttribute('data-film-ready');
      sync(film);
    });
    render(film);
  }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const film = films.find(item => item.video === entry.target);
        film.intersecting = entry.isIntersecting;
      });
      schedule();
    }, {threshold:[0,.1]});
    films.forEach(film => observer.observe(film.video));
  }
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    films.forEach(film => {
      observer.observe(film.section);
      observer.observe(film.video.parentElement);
      if (film.cover) observer.observe(film.cover);
    });
    if (header) observer.observe(header);
  }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) films.forEach(sync);
    else schedule();
  });
  const preferenceChanged = () => {
    if (restricted()) films.forEach(film => { film.userStarted = false; });
    films.forEach(sync);
    schedule();
  };
  reduced.addEventListener('change', preferenceChanged);
  connection?.addEventListener?.('change', preferenceChanged);
  schedule();
})();

// Other decorative films retain their short introduction and final still.
(() => {
  const sections = [...document.querySelectorAll('[data-mz-film]')].filter(section => !section.closest('.mz-home'));
  if (!sections.length) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let enabled = !reduced.matches && !navigator.connection?.saveData;
  const films = sections.map(section => ({section, video:section.querySelector('video'), visible:false, failed:false, finished:false, pending:false})).filter(film => film.video);
  const sync = film => {
    const {video} = film;
    if (!enabled || !film.visible || document.hidden || film.failed || film.finished) { video.pause(); return; }
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    video.muted = true;
    if (!video.paused || film.pending) return;
    film.pending = true;
    video.play().catch(error => {
      if (error.name !== 'AbortError') { film.failed = true; film.section.removeAttribute('data-film-ready'); }
    }).finally(() => { film.pending = false; });
  };
  const syncAll = () => {
    films.forEach(sync);
  };
  for (const film of films) {
    film.video.loop = false;
    film.video.addEventListener('timeupdate', () => {
      if (film.video.currentTime >= 4.5) { film.finished = true; film.video.pause(); }
    });
    film.video.addEventListener('ended', () => { film.finished = true; });
    film.video.addEventListener('playing', () => film.section.setAttribute('data-film-ready',''));
    film.video.addEventListener('error', () => { film.failed = true; film.section.removeAttribute('data-film-ready'); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { film.visible = entry.isIntersecting; sync(film); }, {threshold:.1}).observe(film.section);
    }
  }
  reduced.addEventListener('change', () => { enabled = !reduced.matches && !navigator.connection?.saveData; syncAll(); });
  document.addEventListener('visibilitychange', syncAll);
})();

// Circulate the original reels only while visible. No cloned downloads or
// replaced product content; touch/keyboard interaction stops automatic motion.
document.querySelectorAll('[data-mz-reels]').forEach(reels => {
  const related = document.querySelector('.mz-related');
  if (related && !window.Shopify?.designMode) related.before(reels);
  const viewport = reels.querySelector('.mz-reels__viewport');
  const track = reels.querySelector('.mz-reels__track');
  const toggle = reels.querySelector('.mz-reels__toggle');
  const videos = [...reels.querySelectorAll('video')];
  if (!videos.length || !('IntersectionObserver' in window)) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let enabled = !reduced.matches && !navigator.connection?.saveData;
  let visible = false, hovering = false, focused = false, frame = 0, last = 0;
  let offset = viewport.scrollLeft;
  const representativeReel = track.firstElementChild;
  let geometryDirty = true, step = 0, scrollRange = 0;
  const visibleVideos = new Set();
  const failed = new WeakSet();
  const pending = new WeakSet();
  const render = () => {
    toggle.hidden = false;
    toggle.textContent = enabled ? 'Pause' : 'Play';
    toggle.setAttribute('aria-label', `${enabled ? 'Pause' : 'Play'} video carousel`);
    toggle.setAttribute('aria-pressed', String(!enabled));
  };
  const syncVideos = () => {
    const playing = enabled && visible && !document.hidden
      ? [...visibleVideos].sort((a,b) => a.getBoundingClientRect().left - b.getBoundingClientRect().left).slice(0,3) : [];
    videos.forEach(video => {
      if (!playing.includes(video) || failed.has(video)) { video.pause(); return; }
      if (!video.paused || pending.has(video)) return;
      video.muted = true;
      pending.add(video);
      video.play().catch(error => {
        // Scrolling out of view intentionally interrupts pending playback.
        // That interruption must not permanently disable a healthy clip.
        if (error.name !== 'AbortError') failed.add(video);
      }).finally(() => pending.delete(video));
    });
  };
  const canMove = () => {
    if (!enabled || !visible || document.hidden || hovering || focused) return false;
    if (geometryDirty) {
      // Reels share a fixed width. Recycling changes their order, not their
      // geometry; measure only when the strip enters view or changes size.
      step = representativeReel.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
      scrollRange = viewport.scrollWidth - viewport.clientWidth;
      geometryDirty = false;
    }
    // One complete offscreen reel is needed for an invisible recycle. Smaller
    // libraries stay a normal, manually scrollable strip.
    return step > 0 && scrollRange >= step;
  };
  const tick = now => {
    frame = 0;
    if (!canMove()) { last = 0; return; }
    if (last) offset += Math.min(now - last, 80) * .018;
    last = now;
    const first = track.firstElementChild;
    if (offset >= step) {
      // The first reel is fully offscreen; recycle it at the other end without
      // a visible reset. Never reorder a focused or actively touched video.
      track.append(first);
      offset -= step;
    }
    viewport.scrollLeft = offset;
    frame = requestAnimationFrame(tick);
  };
  const syncMotion = () => {
    if (!canMove()) { cancelAnimationFrame(frame); frame = 0; last = 0; }
    else if (!frame) { offset = viewport.scrollLeft; frame = requestAnimationFrame(tick); }
    syncVideos(); render();
  };
  toggle.addEventListener('click', () => { enabled = !enabled; syncMotion(); });
  const stopForInteraction = () => { enabled = false; syncMotion(); };
  viewport.addEventListener('pointerdown', stopForInteraction, {passive:true});
  viewport.addEventListener('wheel', stopForInteraction, {passive:true});
  viewport.addEventListener('keydown', event => {
    if (['ArrowLeft','ArrowRight','Home','End',' '].includes(event.key)) stopForInteraction();
  });
  viewport.addEventListener('mouseenter', () => { hovering = true; syncMotion(); });
  viewport.addEventListener('mouseleave', () => { hovering = false; syncMotion(); });
  viewport.addEventListener('focusin', () => { focused = true; syncMotion(); });
  viewport.addEventListener('focusout', event => {
    focused = viewport.contains(event.relatedTarget); syncMotion();
  });
  new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    if (visible) geometryDirty = true;
    syncMotion();
  }, {threshold:.1}).observe(reels);
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= .15) visibleVideos.add(entry.target);
      else visibleVideos.delete(entry.target);
    });
    syncVideos();
  }, {threshold:[0,.15]});
  videos.forEach(video => {
    observer.observe(video);
    video.addEventListener('error', () => { failed.add(video); video.pause(); });
    // A promise may finish after a shopper has scrolled away or paused.
    video.addEventListener('playing', () => { if ((!enabled && pending.has(video)) || !visible || document.hidden || !visibleVideos.has(video)) video.pause(); });
  });
  const resize = new ResizeObserver(() => { geometryDirty = true; syncMotion(); });
  [viewport, track, representativeReel].forEach(element => resize.observe(element));
  document.addEventListener('visibilitychange', () => { geometryDirty = true; syncMotion(); });
  reduced.addEventListener('change', () => { enabled = !reduced.matches && !navigator.connection?.saveData; syncMotion(); });
  render();
});

// Once-per-visit shopping reveals. Content is visible even without this enhancement.
(() => {
  const home = document.querySelector('.mz-home');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (!home || reduced.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const small = matchMedia('(max-width: 749px)');
  const running = new Map();
  const targets = new Map();
  const add = (selector, kind) => home.querySelectorAll(selector).forEach((element, index) => targets.set(element, {kind,index}));
  add('.mz-featured .mz-section-heading', 'heading');
  add('.mz-featured .mz-card', 'product');
  add('.mz-heritage-art', 'photograph');
  add('.mz-heritage-copy', 'story-right');
  add('.mz-kaze-copy', 'story-left');
  add('.mz-service-copy > div', 'service');
  const reveal = element => {
    const {kind,index} = targets.get(element);
    const mobile = small.matches;
    let from = {opacity:.3, transform:'translateY(14px)'};
    let to = {opacity:1, transform:'translateY(0)'};
    let duration = 520, delay = 0;
    if (kind === 'product') {
      from = {opacity:.25,transform:`translateY(${mobile ? 16 : 26}px)`};
      duration = 620;
      delay = (index % (mobile ? 2 : 4)) * 65;
    } else if (kind === 'photograph') {
      from = {opacity:.5,clipPath:'inset(5% 0 5% 0)',transform:'scale(1.025)'};
      to = {opacity:1,clipPath:'inset(0% 0 0% 0)',transform:'scale(1)'};
      duration = 780;
    } else if (kind.startsWith('story')) {
      from = {opacity:.3};
      from.transform = mobile ? 'translateY(14px)' : `translateX(${kind === 'story-left' ? -18 : 18}px)`;
      to.transform = 'translate(0,0)';
      duration = 650;
    } else if (kind === 'service') {
      from = {opacity:.4}; to = {opacity:1}; duration = 380;
      delay = mobile ? 0 : index * 45;
    }
    const animation = element.animate([from,to], {duration,delay,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});
    running.set(element,animation);
    animation.finished.then(() => running.delete(element), () => running.delete(element));
  };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      if (!reduced.matches && !entry.target.contains(document.activeElement)) reveal(entry.target);
    }
  }, {threshold:.12,rootMargin:'0px 0px -24px 0px'});
  for (const element of targets.keys()) {
    const rect = element.getBoundingClientRect();
    // Do not replay an entrance on content already visible after navigation/scroll restoration.
    if (rect.top < innerHeight && rect.bottom > 0) continue;
    observer.observe(element);
  }
  home.addEventListener('focusin', event => {
    for (const element of targets.keys()) {
      if (!element.contains(event.target)) continue;
      observer.unobserve(element);
      running.get(element)?.cancel();
    }
  });
  reduced.addEventListener('change', () => {
    if (!reduced.matches) return;
    observer.disconnect();
    running.forEach(animation => animation.cancel());
    running.clear();
  });
})();
